import { useEffect, useMemo, useState } from "react";
import { GenericModal } from "../../GenericModal/GenericModal";

import { DataTable } from "../../DataTable";
import { delay, Message } from "../../../utils";
import { EditOptionModal, CreateOptionModal } from "..";
import { daysOfWeek, DeliverAreaDataColums } from "../../../constants";

import { createAddressOption, deleteAddressOption } from "../../../service/api/AddressOptions/apiDeliver";

const DeliveryAreaSheet = ({ data }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const [optionData, setOptionData] = useState([]);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [editOption, setEditOption] = useState(false);
    const [statusFilter, setStatusFilter] = useState(urlParams.get("status") ?? 'all'); // 寄送狀態
    const [weekFilter, setWeekFilter] = useState(urlParams.get("week") ?? 'all'); // 寄送狀態
    const [filterText, setFilterText] = useState("");
    const [showColumnSelector, setShowColumnSelector] = useState(false); // 篩選區域顯示開關

    const filteredItems = useMemo(() => {
        return optionData.filter(item => {

            // 完成狀態篩選
            const matchStatus =
                statusFilter === 'all' ||
                (statusFilter === '0' && !item.available) ||
                (statusFilter === '1' && item.available);

            // 日期篩選
            const matchDate =
                weekFilter === 'all' ||
                (weekFilter === '1' && item.deliveryWeek === 1) ||
                (weekFilter === '2' && item.deliveryWeek === 2) ||
                (weekFilter === '3' && item.deliveryWeek === 3) ||
                (weekFilter === '4' && item.deliveryWeek === 4) ||
                (weekFilter === '5' && item.deliveryWeek === 5) ||
                (weekFilter === '6' && item.deliveryWeek === 6) ||
                (weekFilter === '7' && item.deliveryWeek === 7)

            // return matchID && matchText && matchStatus && matchReview && matchDate;
            return matchStatus && matchDate;
        });
    }, [optionData, statusFilter, weekFilter]);


    useEffect(() => {
        if (data) {
            console.log(data);
            setOptionData(data);
        }
    }, [data]);

    const allColumns = [
        ...DeliverAreaDataColums,
        {
            name: "操作",
            cell: row =>
                <div className="row-actions">
                    <button className="btn btn-action--primary btn-action--sm" onClick={() => { setEditOption(row); console.log(row) }} >編輯</button>
                    <button className="btn btn-action--danger btn-action--sm" onClick={() => handleDeletedOption(row)} >刪除</button>
                </div>,
            key: "action"
        },
    ];
    const [selectedColumns, setSelectedColumns] = useState(
        allColumns
            .map(col => col.key)
            .filter(key => /*key !== "addressDistrict" &&*/ key !== "check") // 預設不勾選 區、check
    );
    const toggleColumn = key => setSelectedColumns(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
    const columnsToShow = allColumns.filter(col => selectedColumns.includes(col.key));

    const handleDeletedOption = async (data) => {
        const confirmAction = window.confirm("確定要刪除該紀錄嗎？");
        if (!confirmAction) return;
        console.log(data)
        const response = await deleteAddressOption(data);

        if (response.status === 200 && response.data.status === 1) {
            Message(response.data.message);
            console.log(response.status);
            await delay(1);
            setOptionData(optionData.filter(item => item.id !== data.id));
        } else {
            Message(response.data.message, 'warning');
            console.log(response.status);
        }
    };

    const handleAddOption = async (newOption) => {
        console.log(newOption)
        const response = await createAddressOption(newOption);

        if (response.status === 200 && response.data.status === 1) {
            Message(response.data.message);
            await delay(1);
            console.log(response.status);
            setIsCreateOpen(false);
            setOptionData(prev => [...prev, response.data.result]);
        } else {
            Message(response.data.message, 'warning');
        }
    };

    return (
        <>
            <GenericModal isOpen={editOption}>
                <EditOptionModal
                    data={data}
                    option={editOption}
                    setOptionData={setOptionData}
                    onClose={() => setEditOption(false)} />
            </GenericModal>
            <GenericModal isOpen={isCreateOpen}>
                <CreateOptionModal
                    onSubmit={handleAddOption}
                    onCancel={(e) => { setIsCreateOpen(false); e.preventDefault(); }}
                />
            </GenericModal>
            <div className="card-header d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-2 gap-md-0">
                <div className="d-flex align-items-center">
                    <h6 className="m-0 fw-bold text-primary">
                        <i className="fas fa-table me-2"></i>運送區域列表
                    </h6>
                </div>
                <div className="sheet-actions">
                    <input
                        type="text"
                        placeholder="搜尋"
                        className="form-control ms-2 me-2 mt-3 mb-3"
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                        style={{ maxWidth: "200px" }}
                    />
                    <button
                        onClick={() => setIsCreateOpen(true)}
                        className="btn btn-action--confirm"
                    >
                        <i className="fas fa-plus me-2 "></i>新增區域
                    </button>
                </div>
            </div>
            {/* 額外篩選區塊 */}
            <div className="card-body border-top sheet-toolbar">
                <div className="sheet_filter_container">
                    {/* 狀態篩選 */}
                    <div className="sheet_filter">

                        {/* 已送達篩選 */}
                        <div className="d-flex gap-1">
                            <button
                                className={`btn btn-action--sm ${statusFilter === 'all' ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                onClick={() => setStatusFilter('all')}
                            >全部</button>
                            <button
                                className={`btn btn-action--sm ${statusFilter === '0' ? 'btn-action--confirm' : 'btn-action--neutral btn-action--soft'}`}
                                onClick={() => setStatusFilter('0')}
                            >啟用</button>
                            <button
                                className={`btn btn-action--sm ${statusFilter === '1' ? 'btn-action--warning' : 'btn-action--neutral btn-action--soft'}`}
                                onClick={() => setStatusFilter('1')}
                            >停用</button>
                        </div>

                        {/* 星期篩選 */}
                        <div className="d-flex form-control ms-2 me-2 gap-1">
                            <button
                                className={`btn btn-action--sm ${weekFilter === 'all' ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                onClick={() => setWeekFilter('all')}
                            >全部</button>
                            {
                                daysOfWeek.map(week => {
                                    return <button
                                        className={`btn btn-action--sm ${weekFilter === week.value ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                        onClick={() => setWeekFilter(week.value)}
                                    >{week.label}</button>
                                })
                            }

                        </div>
                        <div className="sheet-actions">
                            <button
                                className="btn btn-action--neutral btn-action--soft btn-action--sm"
                                onClick={() => setShowColumnSelector(prev => !prev)}
                            >
                                {showColumnSelector ? "收起欄位" : "選擇欄位"}
                            </button>
                        </div>
                    </div>
                </div>
                
                <div className="d-flex flex-wrap gap-2 mt-3">
                    {showColumnSelector &&
                        allColumns.map(col => {
                            const isSelected = selectedColumns.includes(col.key);
                            return (
                                <button
                                    key={col.key}
                                    type="button"
                                    className={`btn btn-action--sm ${isSelected ? 'btn-action--primary' : 'btn-action--neutral btn-action--soft'}`}
                                    onClick={() => toggleColumn(col.key)}
                                >
                                    {col.name} {isSelected && <span className="badge bg-light text-dark ms-1">✓</span>}
                                </button>
                            )
                        })
                    }
                </div>
            </div>

            <DataTable
                columns={columnsToShow}
                data={filteredItems}
                pagination
                noDataComponent="無此訂單資訊"
                paginationComponentOptions={{
                    rowsPerPageText: '每頁筆數',
                    rangeSeparatorText: '總共',
                }} />

        </>
    );
};

export { DeliveryAreaSheet };
